<template>
    <b-card
        no-body
    >
        <b-card-header>
            <b-card-title class="d-flex justify-content-start">
                <div class="mr-1 line-height-1">
                    <feather-icon class="text-warning" size="17" icon="UserIcon" />
                </div>
                {{ $t('org.auth.customerInformation') }}
            </b-card-title>
        </b-card-header>
        <b-card-body v-if="userInfo.singedTcDt !== null">
            <div>
                <div class="mb-1 d-flex justify-content">
                    <b-avatar square class="mr-1" variant="light-primary" size="43">
                        <feather-icon size="21" icon="MailIcon"/>
                    </b-avatar>
                    <span>
                        <h5>
                            <span class="font-weight-bold">ID({{$t("org.auth.email")}})</span>
                        </h5>
                        <h5>> {{ userInfo.email }}</h5>
                    </span>
                </div>
                <div class="mb-1 d-flex justify-content">
                    <b-avatar square class="mr-1" variant="light-primary" size="43">
                        <feather-icon size="21" icon="UserIcon"/>
                    </b-avatar>
                    <span>
                        <h5>
                            <span class="font-weight-bold">{{$t("org.auth.customerName")}}</span>
                        </h5>
                        <h5>> {{ userInfo.userName }}</h5>
                    </span>
                </div>
                <div class="mb-1 d-flex justify-content">
                    <b-avatar square class="mr-1" variant="light-primary" size="43">
                        <feather-icon size="21" icon="FeatherIcon"/>
                    </b-avatar>
                    <span>
                        <h5>
                            <span class="font-weight-bold">{{$t("org.auth.dateRegistered")}}</span>
                        </h5>
                        <h5>> {{ userInfo.createdt }}</h5>
                    </span>
                </div>
                <div class="mb-1 d-flex justify-content">
                    <b-avatar square class="mr-1" variant="light-primary" size="43">
                        <feather-icon size="21" icon="LayersIcon"/>
                    </b-avatar>
                    <span>
                        <h5>
                            <span class="font-weight-bold">{{$t("org.auth.service")}}</span>
                        </h5>
                        <!-- <h5 v-for="(service, index) in authUserResource.serviceGroups" :key="index">
                            > <a :href="moveService(service)" :target="'_'+service.name.replace('-','')" class="text-info">
                                {{ service.name.charAt(0).toUpperCase() + service.name.slice(1) }}
                            </a>
                        </h5> -->
                        <template v-if="serviceGroups !== undefined">
                            <h5 v-for="(service, index) in serviceGroups" :key="index">
                                <b-badge style="cursor:pointer;text-overflow:ellipsis;overflow:hidden" @click="moveService(service)">{{ service.name.toUpperCase() }}</b-badge>
                            </h5>
                        </template>
                        <template v-else>
                            <h5>> {{$t("org.message.Prerequisites are required")}}</h5>
                        </template>
                    </span>
                </div>
            </div>
            <!-- <div v-else class="d-flex justify-content-center">
                <b-spinner label="Loading..." />
            </div> -->
        </b-card-body>
        <b-card-body v-else>
            <b-button variant="danger" block @click="goToMenu('agreement')">
                <feather-icon icon="CheckSquareIcon" />
                <span class="ml-1">{{ $t('org.auth.youCanKeepUsingIfYouAgree') }}</span>
            </b-button>
        </b-card-body>
    </b-card>
</template>

<script>
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
export default {
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        /* data */
        const stateFlag = ref(false)

        /* computed */
        const authUserInfo = computed(() => store.getters.authUserInfo)
        const userInfo = computed(() => store.getters.userInfo)
        const serviceGroups = computed(() => store.getters.authServiceGroups)

        /* methods */
        const moveService = (serviceGroup) => {
            const token = localStorage.getItem('x-auth-token')
            // vm.$router.push(`${serviceGroup.domain}/signin/email/${authUserInfo.value.email}/token/${token}`)
            window.open(`${serviceGroup.domain}/signin/email/${authUserInfo.value.email}/token/${token}`)
        }
        const goToMenu = (menu) => {
            vm.$router.push('/agreement')
        }

        return {
            stateFlag,
            authUserInfo,
            serviceGroups,
            userInfo,
            moveService,
            goToMenu
        }
    }
}
</script>

<style>

</style>
